import { Flex } from 'pcln-design-system'
import styled from 'styled-components'

export const LinkFlex = styled(Flex)`
  flex-grow: 1;
  flex-basis: 340px;
  flex-shrink: 1;
`
